import Vue from 'vue'
import moment from 'moment'
import {
  postFortniteMetaComment,
  postFortniteMetaCommentVote,
  postFortniteVoteableVote
} from '@/api/fortnite'

const state = () => ({
  metaNews: {},
  weapons: [],
  tierList: [],
  selectedPatchIndex: 0
})

const mutations = {
  'SET_FORTNITE_META_NEWS': (state, payload) => {
    Vue.set(state, 'metaNews', payload)
  },
  'SET_FORTNITE_PATCH_NOTE_COMMENTS': (state, payload) => {
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey],
      'comments',
      payload.comments
    )
  },
  'SET_FORTNITE_PATCH_NOTE_VOTES': (state, payload) => {
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey],
      'votes',
      payload.votes
    )
  },
  'SET_FORTNITE_PATCH_NOTE_VOTE': (state, payload) => {
    // set vote amount
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].votes,
      payload.voteKey,
      payload.voteAmount
    )

    // set user voted
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].votes,
      payload.userVotedKey,
      payload.userVotedValue
    )
  },
  'SET_FORTNITE_META_PARENT_COMMENT_VOTE': (state, payload) => {
    // set vote amount
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey],
      payload.voteKey,
      payload.voteAmount
    )

    // set user voted
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey],
      payload.userVotedKey,
      payload.userVotedValue
    )
  },
  'SET_FORTNITE_META_REPLY_COMMENT_VOTE': (state, payload) => {
    // set vote amount
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey].children[payload.replyKey],
      payload.voteKey,
      payload.voteAmount
    )

    // set user voted
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey].children[payload.replyKey],
      payload.userVotedKey,
      payload.userVotedValue
    )
  },
  'VOTE_FORTNITE_META_PARENT_COMMENT': (state, payload) => {
    let commentIndex = state.comments.indexOf(state.comments.find((obj) => {
      return obj.index === payload.index
    }))
    let comment = state.comments[commentIndex]
    if (payload.voteType === 'upvote') {
      if (comment.userVoted === 'downvote') {
        Vue.set(state.comments[commentIndex], 'downvotes', (comment.downvotes - 1))
      }
      if (comment.userVoted !== 'upvote') {
        Vue.set(state.comments[commentIndex], 'upvotes', (comment.upvotes + 1))
        Vue.set(state.comments[commentIndex], 'userVoted', 'upvote')
      }
    } else if (payload.voteType === 'downvote') {
      if (comment.userVoted === 'upvote') {
        Vue.set(state.comments[commentIndex], 'upvotes', (comment.upvotes - 1))
      }
      if (comment.userVoted !== 'downvote') {
        Vue.set(state.comments[commentIndex], 'downvotes', (comment.downvotes + 1))
        Vue.set(state.comments[commentIndex], 'userVoted', 'downvote')
      }
    }
  },
  'VOTE_FORTNITE_META_REPLY_COMMENT': (state, payload) => {
    let replyCommentIndex
    let parentCommentIndex = state.comments.indexOf(state.comments.find((obj) => {
      if (obj.replies) {
        let tempIndex = obj.replies.indexOf(obj.replies.find((obj) => {
          return obj.index === payload.index
        }))
        if (tempIndex >= 0) {
          replyCommentIndex = tempIndex
          return 1
        }
      }
    }))

    let replies = state.comments[parentCommentIndex].replies
    if (replies) {
      if (replies.length > 0) {
        let comment = replies[replyCommentIndex]
        if (payload.voteType === 'upvote') {
          if (comment.userVoted === 'downvote') {
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'downvotes', (comment.downvotes - 1))
          }
          if (comment.userVoted !== 'upvote') {
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'upvotes', (comment.upvotes + 1))
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'userVoted', 'upvote')
          }
        } else if (payload.voteType === 'downvote') {
          if (comment.userVoted === 'upvote') {
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'upvotes', (comment.upvotes - 1))
          }
          if (comment.userVoted !== 'downvote') {
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'downvotes', (comment.downvotes + 1))
            Vue.set(state.comments[parentCommentIndex].replies[replyCommentIndex], 'userVoted', 'downvote')
          }
        }
      }
    }
  },
  // 'SUBMIT_FORTNITE_META_COMMENT_REPLY': (state, payload) => {
  //   let parentIndex = state.comments.indexOf(state.comments.find((obj) => {
  //     return obj.index === payload.index
  //   }))
  //   console.log(parentIndex)
  //   if (parentIndex >= 0) {
  //     if (state.comments[parentIndex]) {
  //       if (state.comments[parentIndex].replies) {
  //         state.comments[parentIndex].replies.splice(0, 0, payload.comment)
  //       }
  //     }
  //   }
  // },
  'VOTE_FORTNITE_META_PATCH_NOTE': (state, payload) => {
    for (var i = 0; i < state.metaNews.length; i++) {
      if (state.metaNews[i].patch_notes) {
        let patchNoteIndex = state.metaNews[i].patch_notes.indexOf(
          state.metaNews[i].patch_notes.find((obj) => {
            return obj.id === payload.rootId
          })
        )
        if (patchNoteIndex >= 0) {
          let votes = state.metaNews[i].patch_notes[patchNoteIndex].votes
          if (votes) {
            if (payload.voteType === 'upvote') {
              if (votes.user_voted !== 'upvote') {
                let upvotes = votes.upvotes
                Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'upvotes', upvotes + 1)
              }
              if (votes.user_voted === 'downvote') {
                let downvotes = votes.downvotes
                Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'downvotes', downvotes - 1)
              }
              Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'user_voted', 'upvote')
            } else if (payload.voteType === 'downvote') {
              if (votes.user_voted !== 'downvote') {
                let downvotes = votes.downvotes
                Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'downvotes', downvotes + 1)
              }
              if (votes.user_voted === 'upvote') {
                let upvotes = votes.upvotes
                Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'upvotes', upvotes - 1)
              }
              Vue.set(state.metaNews[i].patch_notes[patchNoteIndex].votes, 'user_voted', 'downvote')
            }
          }
        }
      }
    }
  },
  'ADD_FORTNITE_META_COMMENT': (state, payload) => {
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments,
      payload.comment.id,
      payload.comment
    )
  },
  'ADD_FORTNITE_META_COMMENT_CHILD': (state, payload) => {
    Vue.set(
      state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.parentCommentKey].children,
      payload.comment.id,
      payload.comment
    )
  },
  'SET_FORTNITE_WEAPONS': (state, payload) => {
    Vue.set(state, 'weapons', payload)
  },
  'SET_FORTNITE_TIER_LIST': (state, payload) => {
    Vue.set(state, 'tierList', payload)
  },
  'SET_SELECTED_PATCH_INDEX': (state, payload) => {
    Vue.set(state, 'selectedPatchIndex', payload)
  }
}

const actions = {
  setSelectedPatchIndex ({commit}, payload) {
    commit('SET_SELECTED_PATCH_INDEX', payload)
  },
  setFortnitePatchNoteComments ({commit}, payload) {
    let commentsDict = {}

    let comments = payload.comments

    // create comments dict for easy access by id
    for (let i = 0; i < comments.length; i++) {
      let tempComment = comments[i]
      if (tempComment) {
        // create children comment dict for easy access by id
        let childrenDict = {}
        let tempChildren = tempComment.children
        if (tempChildren) {
          if (tempChildren.length > 0) {
            for (let j = 0; j < tempChildren.length; j++) {
              let tempChild = tempChildren[j]

              // prepend @parent_username to child comments if this is a reply to a reply
              if (tempChild) {
                if (tempChild.parent_comment_id) {
                  if (tempChild.parent_comment_id !== tempComment.id) {
                    let parentName
                    if (tempComment.author) {
                      if (tempComment.author.username) {
                        parentName = tempComment.author.username
                      }
                    }
                    if (parentName) {
                      tempChild.message = '@' + parentName + ' ' + tempChild.message
                    }
                  }
                }
                childrenDict[tempChild.id] = tempChild
              }
            }
          }
        }
        tempComment.children = childrenDict

        commentsDict[tempComment.id] = tempComment
      }
    }

    let commentsPayload = {
      comments: commentsDict,
      patchKey: payload.patchKey,
      patchNoteKey: payload.patchNoteKey
    }

    commit('SET_FORTNITE_PATCH_NOTE_COMMENTS', commentsPayload)
  },
  setFortnitePatchNoteVotes ({commit}, payload) {
    let tempVotes = payload.votes
    if (tempVotes) {
      if (tempVotes.upvotes) {
        tempVotes.upvotes = parseInt(tempVotes.upvotes)
      }
      if (tempVotes.downvotes) {
        tempVotes.downvotes = parseInt(tempVotes.downvotes)
      }
    }
    payload.votes = tempVotes
    commit('SET_FORTNITE_PATCH_NOTE_VOTES', payload)
  },
  setFortniteMetaNews ({commit}, payload) {
    // first construct dictionary out of metaNews array
    let metaNewsDict = {}
    for (let i = 0; i < payload.length; i++) {
      if (payload[i]) {
        let key = payload[i].version

        // convert array of patch notes into dict for easy access by id
        let notes = payload[i].patch_notes
        let notesDict = {}
        for (let j = 0; j < notes.length; j++) {
          notesDict[notes[j].id] = notes[j]
        }

        let tempPatch = payload[i]
        tempPatch['patch_notes'] = notesDict

        metaNewsDict[key] = tempPatch
      }
    }
    commit('SET_FORTNITE_META_NEWS', metaNewsDict)
  },
  voteFortniteMetaPatchNote ({commit, state}, payload) {
    let votePayload = {
      root_id: payload.patchNoteKey,
      vote: payload.voteKey
    }
    postFortniteVoteableVote(votePayload).then((response) => {
    }).catch((error) => {
      console.log(error)
    })

    let tempVotes = state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].votes
    if (payload.voteKey === 'upvote') {
      if (tempVotes.user_upvoted) {
      } else if (tempVotes.user_downvoted) {
        let upvotePayload = {
          ...payload,
          voteAmount: (tempVotes.upvotes + 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: true
        }
        upvotePayload.voteKey = 'upvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', upvotePayload)
        let downvotePayload = {
          ...payload,
          voteAmount: (tempVotes.downvotes - 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: false
        }
        downvotePayload.voteKey = 'downvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', downvotePayload)
      } else {
        let upvotePayload = {
          ...payload,
          voteAmount: (tempVotes.upvotes + 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: true
        }
        upvotePayload.voteKey = 'upvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', upvotePayload)
      }
    } else if (payload.voteKey === 'downvote') {
      if (tempVotes.user_downvoted) {
      } else if (tempVotes.user_upvoted) {
        let downvotePayload = {
          ...payload,
          voteAmount: (tempVotes.downvotes + 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: true
        }
        downvotePayload.voteKey = 'downvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', downvotePayload)
        let upvotePayload = {
          ...payload,
          voteAmount: (tempVotes.upvotes - 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: false
        }
        upvotePayload.voteKey = 'upvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', upvotePayload)
      } else {
        let downvotePayload = {
          ...payload,
          voteAmount: (tempVotes.downvotes + 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: true
        }
        downvotePayload.voteKey = 'downvotes'
        commit('SET_FORTNITE_PATCH_NOTE_VOTE', downvotePayload)
      }
    }
    // commit('SET_FORTNITE_PATCH_NOTE_VOTE')
  },
  voteFortniteMetaComment ({commit, state}, payload) {
    let tempComment
    let mutation
    let votePayload = {
      root_id: payload.commentKey,
      vote: payload.voteKey
    }
    if (payload.replyKey) {
      tempComment = state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey].children[payload.replyKey]
      mutation = 'SET_FORTNITE_META_REPLY_COMMENT_VOTE'
      votePayload.root_id = payload.replyKey
    } else {
      tempComment = state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.commentKey]
      mutation = 'SET_FORTNITE_META_PARENT_COMMENT_VOTE'
    }
    postFortniteMetaCommentVote(votePayload).then((response) => {
    }).catch((error) => {
      console.log(error)
    })

    // update frontend store of comment vote optimistic that it will be accurate with the backend
    if (payload.voteKey === 'upvote') {
      if (tempComment.user_upvoted) {
      } else if (tempComment.user_downvoted) {
        let upvotePayload = {
          ...payload,
          voteAmount: (tempComment.upvotes + 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: true
        }
        upvotePayload.voteKey = 'upvotes'
        commit(mutation, upvotePayload)
        let downvotePayload = {
          ...payload,
          voteAmount: (tempComment.downvotes - 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: false
        }
        downvotePayload.voteKey = 'downvotes'
        commit(mutation, downvotePayload)
      } else {
        let upvotePayload = {
          ...payload,
          voteAmount: (tempComment.upvotes + 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: true
        }
        upvotePayload.voteKey = 'upvotes'
        commit(mutation, upvotePayload)
      }
    } else if (payload.voteKey === 'downvote') {
      if (tempComment.user_downvoted) {
      } else if (tempComment.user_upvoted) {
        let downvotePayload = {
          ...payload,
          voteAmount: (tempComment.downvotes + 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: true
        }
        downvotePayload.voteKey = 'downvotes'
        commit(mutation, downvotePayload)
        let upvotePayload = {
          ...payload,
          voteAmount: (tempComment.upvotes - 1),
          userVotedKey: 'user_upvoted',
          userVotedValue: false
        }
        upvotePayload.voteKey = 'upvotes'
        commit(mutation, upvotePayload)
      } else {
        let downvotePayload = {
          ...payload,
          voteAmount: (tempComment.downvotes + 1),
          userVotedKey: 'user_downvoted',
          userVotedValue: true
        }
        downvotePayload.voteKey = 'downvotes'
        commit(mutation, downvotePayload)
      }
    }
  },
  submitFortniteMetaComment ({commit}, payload) {
    let postBody = {
      root_id: payload.patchNoteKey,
      comment: payload.comment,
      language: payload.language
    }
    postFortniteMetaComment(postBody).then((response) => {
      let commentPayload = {
        comment: response,
        patchNoteKey: payload.patchNoteKey,
        patchKey: payload.patchKey
      }
      commit('ADD_FORTNITE_META_COMMENT', commentPayload)
    }).catch((error) => {
      console.log(error)
    })
  },
  submitFortniteMetaCommentReply ({commit, state}, payload) {
    let postBody = {
      root_id: payload.patchNoteKey,
      comment: payload.comment,
      parent_comment_id: payload.parent_comment_id,
      language: payload.language
    }
    postFortniteMetaComment(postBody).then((response) => {
      let tempComment = response
      if (payload.replyCommentKey) {
        let parentComment = state.metaNews[payload.patchKey].patch_notes[payload.patchNoteKey].comments[payload.parentCommentKey].children[payload.replyCommentKey]
        if (parentComment) {
          if (parentComment.author) {
            if (parentComment.author.username) {
              tempComment.message = '@' + parentComment.author.username + ' ' + tempComment.message
            }
          }
        }
      }
      let commentPayload = {
        comment: tempComment,
        patchNoteKey: payload.patchNoteKey,
        patchKey: payload.patchKey,
        parentCommentKey: payload.parentCommentKey
      }
      commit('ADD_FORTNITE_META_COMMENT_CHILD', commentPayload)
    }).catch((error) => {
      console.log(error)
    })
  },
  setFortniteWeapons ({commit}, payload) {
    commit('SET_FORTNITE_WEAPONS', payload)
  },
  setFortniteTierList ({commit}, payload) {
    commit('SET_FORTNITE_TIER_LIST', payload)
  }
}

const getters = {
  getFortniteSelectedPatchIndex: (state) => {
    return state.selectedPatchIndex
  },
  getFortniteSelectedPatch: (state, getters) => {
    return getters.getFortniteMetaNewsArray[state.selectedPatchIndex]
  },
  getFortnitePatchVideo: (state, getters) => {
    if (getters.getFortniteSelectedPatch) {
      if (getters.getFortniteSelectedPatch.patch_videos) {
        if (getters.getFortniteSelectedPatch.patch_videos.length > 0) {
          if (getters.getFortniteSelectedPatch.patch_videos[0]) {
            return getters.getFortniteSelectedPatch.patch_videos[0]
          }
        }
      }
    }
  },
  getFortniteCommentsById: state => id => {
    if (state.comments) {
      return state.comments.filter((obj) => {
        return (obj.id === id)
      })
    }
  },
  getFortniteComments: state => { return state.comments },
  getFortniteMetaNews: state => { return state.metaNews },
  getFortniteMetaNewsArray: (state, getters) => {
    // Sort metaNews by timestamp to get most recent patch first
    let metaNewsArray = Object.values(state.metaNews)
    if (metaNewsArray) {
      if (metaNewsArray.length > 0) {
        return metaNewsArray.sort((a, b) => {
          let aDate
          if (a.date) {
            if (a.date.date) {
              aDate = moment(a.date.date)
            }
          }
          let bDate
          if (b.date) {
            if (b.date.date) {
              bDate = moment(b.date.date)
            }
          }
          if (aDate > bDate) {
            return -1
          } else if (aDate < bDate) {
            return 1
          } else {
            return 0
          }
        })
      }
    }
    return []
  },
  getFortniteWeapons: state => { return state.weapons },
  getFortniteMappedTierList: state => {
    let tierList = state.tierList
    let mapped = {
      s: [],
      a: [],
      b: [],
      c: [],
      d: []
    }
    if (tierList) {
      for (let tier in tierList) {
        for (let i = 0; i < tierList[tier].length; i++) {
          let tempName = tierList[tier][i]
          if (state.weapons[tempName]) {
            mapped[tier].push(state.weapons[tempName])
          }
        }
      }
    }
    return mapped
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/fortnite.js